import axiosInstance from "./config";

export const getAllAttendance = async () => {
  const res = await axiosInstance.get("/attendance/all");
  return res.data;
};
